<template>
  <div class="relative align-middle">
    <h3 class="mt-10 mb-5 w-full">
      Droits restreints
    </h3>
    <h6 class="text-gray-600">
      Vous n’avez pas les droits nécessaires pour accéder à cette page.
    </h6>
    <h6 class="text-gray-600">
      Pour les obtenir, vous devez les demander à l’administrateur de votre structure.
    </h6>

    <div class="flex items-center justify-center mt-15">
      <illustration name="notAllowed" />
    </div>
    <div class="flex items-center justify-center mt-15 mb-15">
      <router-link :to="{ name: 'Dashboard' }">
        <action-button 
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-pink-600"
          bg-color-square="bg-pink-600"
          icon-color="text-white"
          libelle="Revenir à l'accueil"
          :uppercase="true"
          icon="home"
          type-shadow="shadow-pink"
          :enable-action="false"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import Illustration from './Illustration';
import ActionButton from './ActionButton';
export default {
  components:{
    Illustration,
    ActionButton
  },

};
</script>